import React from 'react'
import { IconSVGType } from '../../types/icons'

const ExpandMoreIcon = (props: IconSVGType) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.4425 6.22119L9 9.65619L5.5575 6.22119L4.5 7.27869L9 11.7787L13.5 7.27869L12.4425 6.22119Z'
        fill='black'
        fillOpacity='0.6'
      />
    </svg>
  )
}

export default ExpandMoreIcon
